import {defineMessages} from "@project/i18n";

export const offerTemplateNotesMessages = defineMessages({
  notes: {
    id: "sales.offerTemplates.notes.title",
    defaultMessage: "Notes",
    description: "Template aggregate Notes tab",
  },
  search: {
    id: "sales.offerTemplates.notes.search",
    defaultMessage: "Search Notes",
    description: "Local title/content search",
  },
  empty: {
    id: "sales.offerTemplates.notes.empty",
    defaultMessage: "No Notes match this search.",
    description: "Filtered aggregate Notes empty state",
  },
  table: {
    id: "sales.offerTemplates.notes.table",
    defaultMessage: "Template Notes",
    description: "Accessible Notes table name",
  },
  title: {
    id: "sales.offerTemplates.notes.noteTitle",
    defaultMessage: "Title",
    description: "Note title presentation",
  },
  content: {
    id: "sales.offerTemplates.notes.content",
    defaultMessage: "Content",
    description: "Note content presentation",
  },
  updatedAt: {
    id: "sales.offerTemplates.notes.updatedAt",
    defaultMessage: "Updated",
    description: "Actual canonical updatedAt presentation",
  },
  actions: {
    id: "sales.offerTemplates.notes.actions",
    defaultMessage: "Actions",
    description: "Shared Notes table action column",
  },
  close: {
    id: "sales.offerTemplates.notes.close",
    defaultMessage: "Close Note",
    description: "Read-only detail dismissal",
  },
  copyId: {
    id: "sales.offerTemplates.notes.copyId",
    defaultMessage: "Copy Note ID",
    description: "Copy actual numeric Note identity",
  },
  copyContent: {
    id: "sales.offerTemplates.notes.copyContent",
    defaultMessage: "Copy Note content",
    description: "Copy admitted current Note text",
  },
  copied: {
    id: "sales.offerTemplates.notes.copied",
    defaultMessage: "Copied",
    description: "Clipboard action presentation",
  },
  add: {
    id: "sales.offerTemplates.notes.add",
    defaultMessage: "Add Note",
    description: "Human-confirmed Template Note Add",
  },
  createHelp: {
    id: "sales.offerTemplates.notes.createHelp",
    defaultMessage: "Enter the Note title and content. Cancel discards unsubmitted input.",
    description: "Explicit uniform discard before submission",
  },
  cancel: {
    id: "sales.offerTemplates.notes.cancel",
    defaultMessage: "Cancel",
    description: "Dismiss unsubmitted Note creation",
  },
  createFailed: {
    id: "sales.offerTemplates.notes.createFailed",
    defaultMessage:
      "The Note was not created or current authority changed. Review before retrying.",
    description: "Current unaccepted Note failure",
  },
  created: {
    id: "sales.offerTemplates.notes.created",
    defaultMessage: "Note {noteId} created.",
    description: "Actual201 integer acknowledgement",
  },
  createAccepted: {
    id: "sales.offerTemplates.notes.createAccepted",
    defaultMessage:
      "Note {noteId} was accepted. Refresh to read it; do not repeat this submission.",
    description: "Known acceptance after read withdrawal",
  },
  remove: {
    id: "sales.offerTemplates.notes.remove",
    defaultMessage: "Remove Note",
    description: "Current numeric Note removal",
  },
  removeHelp: {
    id: "sales.offerTemplates.notes.removeHelp",
    defaultMessage: "Remove “{title}”? The Note is permanently removed from this Template.",
    description: "Truthful physical removal confirmation",
  },
  removeFailed: {
    id: "sales.offerTemplates.notes.removeFailed",
    defaultMessage: "Removal failed or the Note changed. Refresh and review before retrying.",
    description: "Current unaccepted removal feedback",
  },
  removeAccepted: {
    id: "sales.offerTemplates.notes.removeAccepted",
    defaultMessage:
      "Removal accepted. Waiting for the actual Note absence; do not repeat the command.",
    description: "Void acknowledgement is not a fabricated Resource",
  },
  removed: {
    id: "sales.offerTemplates.notes.removed",
    defaultMessage: "Note removed.",
    description: "Admitted current Note absence",
  },
  edit: {
    id: "sales.offerTemplates.notes.edit",
    defaultMessage: "Edit Note",
    description: "Whole title/content Note editing",
  },
  editHelp: {
    id: "sales.offerTemplates.notes.editHelp",
    defaultMessage: "Review the captured title and content. Cancel discards unsubmitted changes.",
    description: "Explicit pre-dispatch discard",
  },
  editFailed: {
    id: "sales.offerTemplates.notes.editFailed",
    defaultMessage:
      "The Note was not updated or its current baseline changed. Review before retrying.",
    description: "Current unaccepted Note edit",
  },
  editAccepted: {
    id: "sales.offerTemplates.notes.editAccepted",
    defaultMessage:
      "Edit accepted. Waiting for the actual matching Note read; do not repeat the update.",
    description: "Void submitted-input marker",
  },
  edited: {
    id: "sales.offerTemplates.notes.edited",
    defaultMessage: "Note updated.",
    description: "Matching current Note projection",
  },
  history: {
    id: "sales.offerTemplates.notes.history",
    defaultMessage: "Deleted Template Notes remain readable as history.",
    description: "Supported deleted-history browsing",
  },
});
